import * as d3 from 'd3'

export function buildRoseSVG(svg2, data, tag, value, calm, sideCalm = false) {
  let innerRadius = 25
  let decimalFixed = (tag && (tag.includes("(ppm)") || tag.includes("(mg/m3)"))) ? 2 : 1

  // Validación de entrada
  if (!Array.isArray(data) || data.length === 0 || value === undefined || value === 0) {
    let svg = d3.select(svg2).attr('width', 70).attr('height', 70)
    let width = svg.attr("width") - 20
    let height = svg.attr("height") - 20
    let g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
    g.append("circle").attr("r", innerRadius).attr("fill", "rgba(0,0,0,0.7)")
    g.append("text")
      .attr("text-anchor", "middle").attr("font-family", "Manrope")
      .attr('font-size', '12px').attr('font-weight', 'bold')
      .attr('fill', 'white').attr('y', 5)
      .text(value === undefined ? "-" : parseFloat(value).toFixed(decimalFixed))
    return
  }

  // Configuración SVG y escalas
  let svg = d3.select(svg2)
  svg2.setAttribute("viewBox", "30 -40 220 280");
  svg2.setAttribute("preserveAspectRatio", "xMidYMid meet")
  svg2.style.width = "100%"
  svg2.style.height = "100%"

  let width = 200
  let height = 200
  let outerRadius = Math.min(width, height) / 2
  let g = svg.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")

  let x = d3.scaleBand().range([0, 2 * Math.PI]).align(0)
  let y = d3.scaleRadial().range([innerRadius, outerRadius])
  let colors = []
  data.slice().reverse().forEach(d => colors.push(d.color))
  let z = d3.scaleOrdinal().range(colors)

  // Inicializar estructura
  let dataObj = {
    "N": {}, "NNE": {}, "ENE": {}, "E": {}, "ESE": {}, "SSE": {}, "S": {}, "SSW": {}, "WSW": {}, "W": {}, "WNW": {}, "NNW": {}
  }
  Object.keys(dataObj).forEach(k => {
    dataObj[k].km = k
    dataObj[k].total = 0
  })

  let domains = []
  data.forEach(d => {
    let nameValue = d.name
    domains.push(nameValue)
    d.data.forEach(({ name, value }) => {
      if (!dataObj[name]) return
      dataObj[name][nameValue] = value
      dataObj[name]["total"] += value
    })
  })

  let result = Object.values(dataObj)
  x.domain(result.map(d => d.km))
  y.domain([0, Math.max(5, d3.max(result, d => d.total))])
  z.domain(domains)

  let angleOffset = -360.0 / result.length / 2.0

  // Base circle
  // g.append("circle").attr("r", outerRadius).attr("fill", "rgba(255,255,255,0.6)")
  g.append("circle").attr("r", innerRadius).attr("fill", "rgba(0,0,0,0.7)")
  g.append("text")
    .attr("text-anchor", "middle").attr("font-family", "Manrope")
    .attr('font-size', '12px').attr('font-weight', 'bold')
    .attr('fill', 'white').attr('y', 5)
    .text(parseFloat(value).toFixed(decimalFixed))

  if (calm !== undefined) {
    // g.append("rect").attr("width", 100).attr("height", 15)
      // .attr('fill', 'rgba(255,255,255,0.6)').attr('y', 105).attr('x', -48);
    g.append("text")
      .attr("text-anchor", "middle").attr("font-family", "Manrope")
      .attr('font-size', '12px').attr('font-weight', 'bold')
      .attr('fill', 'black').attr('x', 180)
      .text("Calm " + parseFloat(calm).toFixed(decimalFixed) + " %");
  }

  // Gráfico circular
  g.append("g").selectAll("g")
    .data(d3.stack().keys(domains)(result))
    .enter().append("g")
    .attr("fill", d => z(d.key))
    .selectAll("path").data(d => d)
    .enter().append("path")
    .attr("d", d3.arc()
      .innerRadius(d => y(d[0]))
      .outerRadius(d => y(d[1]))
      .startAngle(d => x(d.data.km))
      .endAngle(d => x(d.data.km) + x.bandwidth())
      .padAngle(0.1).padRadius(innerRadius))
    .attr("transform", `rotate(${angleOffset})`)

  // Ejes de radio
  let yAxis = g.append("g").attr("text-anchor", "middle")
  let yTick = yAxis.selectAll("g").data(y.ticks(3).slice(1)).enter().append("g")
  yTick.append("circle").attr("fill", "none").attr("stroke", "#555555").attr("stroke-dasharray", "4,4").attr("r", y)
  yTick.append("text")
    .attr("y", d => -y(d)).attr("dy", "-0.15em").attr("x", 0)
    .text(d => d + " %").style('fill', 'black').attr('font-size', '11px')

  const keys = Object.keys(dataObj);
  const numDirs = keys.length;
  const labelRadius = outerRadius + 18;
  const centerAngle = -Math.PI / 2;

  keys.forEach((key, i) => {
    const angle = (i / numDirs) * 2 * Math.PI + centerAngle;
    const x = Math.cos(angle) * labelRadius;
    const y = Math.sin(angle) * labelRadius + 5;
    g.append("text")
      .attr("x", x)
      .attr("y", y)
      .attr("text-anchor", "middle")
      .attr("alignment-baseline", "middle")
      .attr("font-family", "Manrope")
      .attr("font-size", "11px")
      .attr("font-weight", "bold")
      .attr("fill", "#222")
      .text(key);
  });
}